var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('Footer'),_vm._m(0),_c('div',{attrs:{"id":"preloader"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"back-to-top",attrs:{"href":"#"}},[_c('i',{staticClass:"ri-arrow-up-line"})])
}]

export { render, staticRenderFns }